<div class="ui container">
  <div class="ui grid">
    <div class="column">
      <h1>Recent Bounty Comments</h1>
      <p>A list of the most recently commented-on bounties</p>
    </div>
  </div>

  <div class="ui doubling stackable grid section">
    <div class="row" *ngFor="let bounty of bounties">
      <div class="five wide column">
        <app-bounty-card [bounty]="bounty" [isListing]="true" [fillHeight]="false"></app-bounty-card>
      </div>
      <div class="eleven wide column">
        <app-comments-section [comments]="bounty.comments" [resourceName]="bounties" [canComment]="false"></app-comments-section>
      </div>
    </div>
  </div>
</div>
